import { render, staticRenderFns } from "./ModificarPedidoItems.vue?vue&type=template&id=e0fa2400&scoped=true&"
import script from "./ModificarPedidoItems.vue?vue&type=script&lang=js&"
export * from "./ModificarPedidoItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fa2400",
  null
  
)

export default component.exports